import { render } from "./AboutS15.vue?vue&type=template&id=23bfd77c&scoped=true"
import script from "./AboutS15.vue?vue&type=script&lang=js"
export * from "./AboutS15.vue?vue&type=script&lang=js"

import "./AboutS15.vue?vue&type=style&index=0&id=23bfd77c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23bfd77c"]])

export default __exports__